module.exports = __webpack_public_path__ + "static/media/view payroll.32491279.svg";